/**
 * Fetches image file as Blob from a given URL.
 * Supports all image MIME types and generic content types.
 * @param url - Blob URL of the image
 */
export const fetchImageAsBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch image: ${response.statusText}`);
  }

  // Do not block based on content type — Azure often returns application/octet-stream
  const contentType = response.headers.get("Content-Type") || "";
  const blob = await response.blob();

  // Validate by actual blob type or file extension
  const validTypes = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/svg+xml",
    "image/tiff",
  ];

  const fileExt = url.split(".").pop()?.toLowerCase() || "";
  const allowedExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff"];

  if (!validTypes.includes(contentType) && !allowedExts.includes(fileExt)) {
    console.warn(`Unrecognized image type: ${contentType} — attempting fallback render.`);
  }

  return blob;
};
